// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__g9sKJ","info":"UpdateTermsInfo_info__3OhMd"};